import { render } from "./SidebarImage.vue?vue&type=template&id=213de5ea"
import script from "./SidebarImage.vue?vue&type=script&lang=js"
export * from "./SidebarImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__